import { Capacitor, registerPlugin } from '@capacitor/core';

export interface SharedFile {
  name: string;
  mimeType: string;
  size?: number;
  path: string;
  uri: string;
}

export interface SharedContentPayload {
  action?: string;
  mimeType?: string;
  text?: string;
  subject?: string;
  files?: SharedFile[];
}

interface SharedContentPlugin {
  getSharedContent(): Promise<{ hasPayload?: boolean; payload?: SharedContentPayload | null }>;
  clearSharedContent(): Promise<void>;
  addListener(
    eventName: 'sharedContentReceived',
    listenerFunc: (payload: SharedContentPayload) => void
  ): Promise<{ remove: () => Promise<void> }>;
}

export const SharedContent = registerPlugin<SharedContentPlugin>('SharedContent');

export const isSharedContentAvailable = (): boolean =>
  Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'ios';

export const sharedFileToBrowserFile = async (shared: SharedFile): Promise<File> => {
  const webUrl = Capacitor.convertFileSrc(shared.uri || shared.path);
  const response = await fetch(webUrl);
  const blob = await response.blob();
  return new File([blob], shared.name || `shared-${Date.now()}`, {
    type: shared.mimeType || blob.type || 'application/octet-stream',
  });
};

export const getPendingSharedContent = async (): Promise<SharedContentPayload | null> => {
  if (!isSharedContentAvailable()) return null;
  const result = await SharedContent.getSharedContent();
  return result.hasPayload && result.payload ? result.payload : null;
};

export const clearPendingSharedContent = async (): Promise<void> => {
  if (!isSharedContentAvailable()) return;
  await SharedContent.clearSharedContent();
};